import moment from "moment-timezone";

import template from "./pFlexitime.html";

export function pFlexitimeDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pFlexitimeController,
    controllerAs: 'pFlexitime',
    bindToController: true,
    scope: {
      teamLeaderVersion: "="
    }
  };

  return directive;
}

const manuallyProjectsFlag = "ProjectsSetManually";
const erpProjectsFlag = "ProjectsFromErpSystem";
const manuallyProjectsSource = "AddedManually";

class pFlexitimeController {
  constructor($rootScope, $scope, $filter, $interval, Auth, DownloadFile, Stats, Work, bModal, Notes, ConnectionQuality) {
    'ngInject';

    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$filter = $filter;
    this.Auth = Auth;
    this.DownloadFile = DownloadFile;
    this.Stats = Stats;
    this.Work = Work;
    this.Notes = Notes;
    this.ConnectionQuality = ConnectionQuality;
    this.bModal = bModal;

    this.state = "loading";
    /* FLEXITIME SPECIFIC */
    this.selectedUser = null;

    //ZAMIENI
    const startDateOrNoDate = sessionStorage.getItem("roedl-tl-date-start") || undefined;
    this.date = moment(startDateOrNoDate);
    this.worklogsChangedForTheDates = false;

    this.dateChoice = moment(startDateOrNoDate).format("YYYY-MM-DD");
    this.dateStart = moment(startDateOrNoDate).startOf('isoWeek');
    this.dateEnd = moment(startDateOrNoDate).endOf('isoWeek');
    this.dateStartChoice = moment(startDateOrNoDate).startOf('isoWeek').format("YYYY-MM-DD");
    this.dateEndChoice = moment(startDateOrNoDate).endOf('isoWeek').format("YYYY-MM-DD");
    this.dates = [
      {date: this.dateStart.clone().add(0, "days")},
      {date: this.dateStart.clone().add(1, "days")},
      {date: this.dateStart.clone().add(2, "days")},
      {date: this.dateStart.clone().add(3, "days")},
      {date: this.dateStart.clone().add(4, "days")},
      {date: this.dateStart.clone().add(5, "days")},
      {date: this.dateStart.clone().add(6, "days")}
    ];

    this.updateDateTrigger = (e, date) => {
      if (this.worklogsChangedForTheDates) {
        this.modalConfig = {
          text: "WORK_DATA.UNSAVED_DATA_CHANGE_DATE_CONFIRMATION",
          cancelText: "CANCEL",
          acceptText: "WORK_DATA.GO_TO_DATE"
        };
        this.bModal.show(this.modalConfig).then(() => {
          this.updateDate(e, date);
        }, angular.noop);
      } else {
        this.updateDate(e, date);
      }
    };


    this.showAll = true;
    this.showAllclientGroupNames = true;
    this.showToAccept = true;
    this.showAccepted = true;
    this.showProcesses = true;
    this.showInterruptions = true;

    this.showAcceptAll = false;
    this.clientGroupNames = [];

    this.allClientGroupNames = [];
    this.clientGroupNames = [];

    this.$rootScope.$on("allWorklogsJobsFinished", () => {
      if (this.$scope) {
        this.getMoreData(true);
      }
    });

    this.$rootScope.$watch(() => this.$rootScope.hiddenClientsGroup, () => this.checkToggleAllGroup(), true);
    this.$rootScope.$watch(() => this.$rootScope.hiddenClients, () => this.checkToggleAllClients(), true);
    this.$rootScope.$watch(() => this.selectedUser, () => this.resetFilters(), true);
    /* END FLEXITIME SPECIFIC */

    if (localStorage.getItem('roedl-dark-background')) {
      document.querySelector('body').classList.add('darkerBackground');
    }

    this.outputTypeFeatureFlag = false;

    this.Auth.authorize().then(
      async (user) => {
        this.user = user;

        if (!this.user.preferences || !this.user.preferences.featureFlags) {
          this.Auth.setFeatureFlagsToLocaleStorage(this.user).then(newUserInfo => {
            this.user = newUserInfo;
            this.invoiceDetailsFeatureFlag = !!this.user.preferences.featureFlags.find(f => f == "InvoiceDetails");
            this.outputTypeFeatureFlag = this.user.preferences.featureFlags.some(ff => ff === "OutputType");
            this.acceptanceHierarchyFlag = this.user.preferences.featureFlags.some(ff => ff === "AcceptanceHierarchy");
            this.overtimeApplicationsFlag = this.user.preferences.featureFlags.some(ff => ff === "OvertimeApplications");
          });
        } else {
          this.invoiceDetailsFeatureFlag = !!this.user.preferences.featureFlags.find(f => f == "InvoiceDetails");
          this.outputTypeFeatureFlag = this.user.preferences.featureFlags.some(ff => ff === "OutputType");
          this.acceptanceHierarchyFlag = this.user.preferences.featureFlags.some(ff => ff === "AcceptanceHierarchy");
          this.overtimeApplicationsFlag = this.user.preferences.featureFlags.some(ff => ff === "OvertimeApplications");
        }

        this.allowedProjects = this.user.preferences.featureFlags.some(flag => { return flag == 'ProjectsSetManually' || flag == "ProjectsFromErpSystem";});

        await this.Work.getCountryBillingTypes()
          .then(({ data: { billingTypes }}) =>
            this.billingTypes = Object.entries(billingTypes).reduce((accu, curr) => {
              accu.push({id: curr[0], name: curr[1]});
              return accu;
            }, [])
          )
          .catch(error => {
            this.state = "error";
            this.error = error;
          });

        const workspacePromise = this.Work.getWorkspace().then(
          (workspaceData) => {
            workspaceData.data.clients.map(client => {
              if (client.additionalInfo) {
                client.nameWithAdditionalInfo = `(${client.additionalInfo}) ${client.name}`;
              }
            });

            this.workspace = workspaceData.data;
            this.clients = workspaceData.data.clients;
            this.clients.forEach((client) => {
              client.show = true;
            });
            this.problems = {};
            this.workspace.problems.map((problem) => {
              this.problems[problem.id] = problem.name;
            });
            if (this.allowedProjects) {this.setClientsFlagsHistory();}
          },
          (error) => {
            this.state = "error";
            this.error = error;
          }
        );



        const getWorklogs = this.Stats.getWorklogs(this.dateStartChoice, this.dateEndChoice);
        const getOvertimes = this.Stats.getOvertimes(this.dateStartChoice, this.dateEndChoice);
        Promise.all([getWorklogs, getOvertimes, workspacePromise]).then(
          (results) => {
            const success = results[0];
            const overtimes = results[1];
            this.dateStart = moment(this.dateStartChoice);
            this.dateEnd = moment(this.dateEndChoice);

            let usersWithEntries = success.data.userWithEntries;
            this.cannotAcceptMyself = !this.user.acceptPersonalWorklogs && this.acceptanceHierarchyFlag && !results[0].data.canAcceptOwnEntries;

            this.summary = {
              ...this.deserializeData(usersWithEntries),
              dates: this.dates
            };


            this.overtimes = overtimes.data;
            this.summary.users.map((user) => {
              const overtimeSummary = this.overtimes.overtimeSummaries.find((x) => x.user.id == user.id);
              user.overtimeSummary = overtimeSummary || {workdayTimes: []};
            });
            this.$scope.$apply();
            // SELECT DEFAULT USER

            if (!this.selectedUser) {
              const currentUser = this.summary.users.find((x) => x.id == this.user.id);
              this.selectedUser = currentUser || this.summary.users[0];
              setTimeout(() => this.$scope.$apply(), 0);
            }
            this.state = "loaded";

          },
          (error) => {
            this.state = "error";
            this.stateWorklog = "error";
            this.error = error;
          }
        );
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );

    this.timeout = $interval(() => {
      this.notes = Notes.getNotes();
    }, 10);

    $scope.$on("$destroy", () => {
      $interval.cancel( this.timeout );
    });

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });

    this.$scope.$watch(() => this.worklogClients, newValue => this.recalculateFilters(newValue), true);
  }

  recalculateFilters(newWorkingClients) {
    this.clientGroupNames = this.allClientGroupNames
      .filter(x => (x.userId === this.selectedUser.id));

    this.clientGroupNames = this.clientGroupNames
      .filter((v, i, a) => a
        .findIndex(t => (t.id === v.id)) === i);

    if (newWorkingClients && this.summary && this.clients) {
      this.clients = this.clients.map((client) => {
        const newValue = newWorkingClients.indexOf(client.id) != -1;
        if (!client.hasWorklogs && newValue) {
          client.show = true;
        }
        client.hasWorklogs = newValue;
        return client;
      });
    }

    if (typeof this.workspace !== 'undefined') {
      this.workspace.clientGroupNames = this.clientGroupNames;
    }
  }

  setClientsFlagsHistory() {
      this.Work.getClientsWithFlagsHistory().then(
        (response) => {
          let allProjectsForClients = response.data.clients || [];
          this.workspace.clientsWithAllProjectsHistory = allProjectsForClients;
          this.projectFlagHistory = response.data.projectFlagHistory || [];
        },
        (error) => {
          this.state = "error";
          this.error = error;
        }
      );
  }

  updateClientsGroups(group, show) {
    let currentWorklogs = this.summary.users.filter(x => (x.id === this.selectedUser.id));
    let worklogWithId = currentWorklogs[0].worklogs.filter(x => (x.clientGroupId === group.id));
    if (group.id !== null){
      let clientIds = [];
      worklogWithId.map(x => clientIds.push(x.clientId));
      clientIds = clientIds.uniq();
      for(let i=0; i < clientIds.length; i++){
       this.clients.map( function (x) {
          if(x.id === clientIds[i]) return x.show = !show;
       });
      }
    }
  }

  checkClientsGroups(client) {
    let currentWorklogs = this.summary.users.find(x => (x.id === this.selectedUser.id));
    let worklogWithId = currentWorklogs.worklogs.find(x => (x.clientId === client.id));
    let clientGroupName = worklogWithId.clientGroupName;
    let clientGroupNameWorklogs = currentWorklogs.worklogs.find(x => (x.clientGroupName === clientGroupName));

    if (clientGroupName !== null) {
      let visibleElements = clientGroupNameWorklogs.map(x => (document.getElementById('reference_' + x.id).parentElement.classList.contains("hidden")));
      if (visibleElements.filter(x => (x === false)).length === 0) {
        let selectedClientGroupName = this.clientGroupNames.find(x => x.name === clientGroupName);
        if (client.show) {
          selectedClientGroupName.show = true;
        }
      }
    }
  }

  toggleShowAll(value) {
    this.showAll = typeof value === 'boolean' ? value : !this.showAll;
    const updateClientShow = (show) => (client) => {
      client.show = show;
      return client;
    };
    this.clients = this.clients.map(updateClientShow(this.showAll));
  }

  toggleShowAllGroupNames() {
    this.showAllclientGroupNames = !this.showAllclientGroupNames;
    const updateShowAllClients = (show) => (clientGroupName) => {
      clientGroupName.show = show;
      return clientGroupName;
    };

    this.toggleShowAll(this.showAllclientGroupNames);

    this.clientGroupNames = this.clientGroupNames.map(updateShowAllClients(this.showAllclientGroupNames));
  }

  getMoreData(update) {
    this.state = "loading";
    this.viewToggledOut = false;
    this.refreshWorklog(update);
  }

  nextWeek() {
    const date = this.date.clone().add(1, 'week');
    this.updateDateTrigger(null, date);
  }

  previousWeek() {
    const date = this.date.clone().subtract(1, 'week');
    this.updateDateTrigger(null, date);
  }

  setupWorklogSource(newWorklogStartDateChoice) {
    if (!this.projectFlagHistory) return null;
    const formattedProjectFlagHistory = this.projectFlagHistory.map(el => {
      return {
        start: el.start && moment(el.start).format("YYYY-MM-DD"),
        end: el.end ? moment(el.end).format("YYYY-MM-DD") : moment().add(1,'days').format("YYYY-MM-DD"), // if no endDate set in future
        flag: el.flag,
        source: el.source
      };
    });

      const flagsThatDay = formattedProjectFlagHistory.filter(el => {
        return moment(el.start).isSameOrBefore(moment(newWorklogStartDateChoice)) && moment(el.end).isSameOrAfter(moment(newWorklogStartDateChoice));
      });

      const lastFlagHistoryThatDay = flagsThatDay.length ? flagsThatDay[flagsThatDay.length - 1] : null;
      const lastFlagThatDay = lastFlagHistoryThatDay.flag;

      if (lastFlagThatDay == manuallyProjectsFlag) return manuallyProjectsSource;
      if (lastFlagThatDay == erpProjectsFlag) return lastFlagHistoryThatDay.source;
      if (lastFlagThatDay == "NoProjectFlag") return null;
  }


  updateDate(e, date) {
    this.date = moment(date);
    this.dateChoice = this.date.format("YYYY-MM-DD");
    this.worklogsChangedForTheDates = false;

    this.dateStart = this.date.clone().startOf('isoWeek');
    this.dateEnd = this.date.clone().endOf('isoWeek');

    this.dateStartChoice = this.dateStart.format("YYYY-MM-DD");
    this.dateEndChoice = this.dateEnd.format("YYYY-MM-DD");

    this.dates = [
      {date: moment(new Date(this.dateStart.clone()).setDate(new Date(this.dateStart.clone()).getDate() + 0))},
      {date: moment(new Date(this.dateStart.clone()).setDate(new Date(this.dateStart.clone()).getDate() + 1))},
      {date: moment(new Date(this.dateStart.clone()).setDate(new Date(this.dateStart.clone()).getDate() + 2))},
      {date: moment(new Date(this.dateStart.clone()).setDate(new Date(this.dateStart.clone()).getDate() + 3))},
      {date: moment(new Date(this.dateStart.clone()).setDate(new Date(this.dateStart.clone()).getDate() + 4))},
      {date: moment(new Date(this.dateStart.clone()).setDate(new Date(this.dateStart.clone()).getDate() + 5))},
      {date: moment(new Date(this.dateStart.clone()).setDate(new Date(this.dateStart.clone()).getDate() + 6))},
    ];

    this.viewToggledOut = moment.duration(this.dateEnd.diff(this.dateStart)).asDays() > 9;

    sessionStorage.setItem("roedl-tl-date-start", this.dateStartChoice);
    sessionStorage.setItem("roedl-tl-date-end", this.dateEndChoice);

    if (!this.viewToggledOut) {
      this.getMoreData('update');
    }
  }

  filterUsers() {
    this.filtersOpen = !this.filtersOpen;
    this.allUsersSelected = this.summary.users.every(u => u.visible);
  }

  selectAllUsers() {
    this.summary.users.forEach(u => u.visible = this.allUsersSelected);
    sessionStorage.setItem("roedl-tl-filtered-users", angular.toJson(this.summary.users.map(u => {
      return {name: u.name, id: u.id, visible: u.visible};
    })));
  }

  deselectUser() {
    if (this.allUsersSelected && this.summary.users.find(u => u.visible != true)) {
      this.allUsersSelected = false;
    }

    if (!this.allUsersSelected && this.summary.users.every(u => u.visible == true)) {
      this.allUsersSelected = true;
    }
    sessionStorage.setItem("roedl-tl-filtered-users", angular.toJson(this.summary.users.map(u => {
      return {name: u.name, id: u.id, visible: u.visible};
    })));
  }

  exportData() {
    this.state = "loading";
    var users = this.summary.users.filter((x) => x.visible).map((x) => x.id);
    return this.Stats.export(this.dateStart.format("YYYY-MM-DD"), this.dateEnd.format("YYYY-MM-DD"), "team", users).then((success) => {
      this.state = "loaded";
      this.DownloadFile.downloadFromResponse(
        success,
        success.headers("content-type"),
        `klix-${this.dateStart.format("YYYY-MM-DD")}-${this.dateEnd.format("YYYY-MM-DD")}-${moment().format("HH:mm")}.xlsx`
      );
    }, (error) => {
      this.error = error;
      this.state = 'error';
    });
  }

  deserializeData(usersWithEntries) {
    const filteredUsers = angular.fromJson(sessionStorage.getItem("roedl-tl-filtered-users"));
    var users = usersWithEntries.map(userWithEntries => {
      const filteredUserVisibility = filteredUsers && filteredUsers.find(user => user.id == userWithEntries.user.id);
      var usersData = userWithEntries.entries
        .map((x) => {
          return this.deserializeWorklog(x);
        });

      if (usersData[usersData.length - 1]) {
        usersData[usersData.length - 1].isLastOne = true;
      }
      // Block last process also, because it can go after last interrupt
      var worklogList = usersData.filter((x) => x.type == "process");
      if (worklogList[worklogList.length - 1]) {
        worklogList[worklogList.length - 1].isLastOne = true;
      }
      return {
        name: userWithEntries.user.fullName,
        id: userWithEntries.user.id,
        allAccepted: usersData.filter((x) => x.approved || x.archived).length == usersData.length,
        visible: filteredUsers && filteredUserVisibility ? filteredUserVisibility.visible : true,
        worklogs: usersData,
        isInCurrentTeam: userWithEntries.isInCurrentTeam,
        isBlocked: userWithEntries.user.blockedAt,
        invoicedTime: userWithEntries.user.invoicedTime
      };

    });

    this.extractedClientGroupNames(users);

    users.sort((a, b) => a.name.localeCompare(b.name));
    // sort after surname (last piece of name)
    users.sort((a, b) => a.name.split(' ').slice(-1)[0].localeCompare(b.name.split(' ').slice(-1)[0]));
    var summary = {
      date: this.dateStart.format("YYYY-MM-DD") + " — " + this.dateEnd.format("YYYY-MM-DD"),
      users: users
    };
    return summary;
  }

  extractedClientGroupNames(users) {
    let worklogClientGroupNamesArr = [];
    users.map(function (x) {
      x.worklogs.map(function (y) {
        if (y.clientGroupName !== null) {
          const clientGroupName = {
            name: y.clientGroupName,
            id: y.clientGroupId,
            userId: y.userId,
            show: true
          };
          worklogClientGroupNamesArr.push(clientGroupName);
        }
      });
    });

    this.allClientGroupNames = worklogClientGroupNamesArr.uniq();
  }

  deserializeWorklog(x) {
    const startedAtTimezoneBeginning = x.startedAt.indexOf("[");
    const startedAtTimezoneEnding = x.startedAt.indexOf("]");
    x.startedAtTime = moment.tz(x.startedAt.substring(0, startedAtTimezoneBeginning), x.startedAt.substring(startedAtTimezoneBeginning + 1, startedAtTimezoneEnding));
    
    const finishedAtTimezoneBeginning = x.finishedAt.indexOf("[");
    const finishedAtTimezoneEnding = x.finishedAt.indexOf("]");
    x.finishedAtTime = moment.tz(x.finishedAt.substring(0, finishedAtTimezoneBeginning), x.finishedAt.substring(finishedAtTimezoneBeginning + 1, finishedAtTimezoneEnding));
    
    x.duration = moment.duration(x.duration);
    x.durationText = this.$filter("hms")(x.duration.toJSON());
    x.type = x.processName && "process" || "interrupt";
    x.isToday = x.startedAtTime.format("YYYY-MM-DD") == moment().format("YYYY-MM-DD");
    x.isFuture = x.startedAtTime.isAfter(moment(), 'day');
    return x;
  }

  refreshWorklog(update) {
    this.showAll = true;
    this.showAllclientGroupNames = true;

    this.clientGroupNames.map(x => x.show = true);

    const workspacePromise = this.Work.getWorkspace().then(
      (workspaceData) => {
        workspaceData.data.clients.map(client => {
          if (client.additionalInfo) {
            client.nameWithAdditionalInfo = (client.additionalInfo ? "(" + client.additionalInfo + ") " : "") + client.name;
          }
        });
        this.workspace = workspaceData.data;
        this.clients = workspaceData.data.clients;
        this.clients.forEach((client) => {
          client.show = true;
        });
        this.problems = {};
        this.workspace.problems.map((problem) => {
          this.problems[problem.id] = problem.name;
        });

        if (this.allowedProjects) {this.setClientsFlagsHistory();}

      },
      (error) => {
        this.error = error;
      }
    );


    var previousSummary = angular.copy(this.summary);
    const getWorklogs = this.Stats.getWorklogs(this.dateStart.format("YYYY-MM-DD"), this.dateEnd.format("YYYY-MM-DD"), update);
    const getOvertimes = this.Stats.getOvertimes(this.dateStartChoice, this.dateEndChoice, update);
    Promise.all([getWorklogs, getOvertimes, workspacePromise]).then((results) => {
      const success = results[0];
      const overtimes = results[1];
      let usersWithEntries = success.data.userWithEntries;

      this.summary = {
        ...this.deserializeData(usersWithEntries),
        dates: this.dates
      };

      const previouslySelected = this.selectedUser &&
        this.summary.users.find((x) => x.id == this.selectedUser.id);
      const currentUser = this.summary.users.find((x) => x.id == this.user.id);
      this.selectedUser = previouslySelected || currentUser || this.summary.users[0];

      if (previousSummary) {
        this.summary.users.map((user) => {
          previousSummary.users.map((previousVersionOfUser) => {
            if (previousVersionOfUser.id == user.id) {
              user.visible = previousVersionOfUser.visible;
            }
          });
        });
      }

      this.overtimes = overtimes.data;
      this.summary.users.map((user) => {
        const overtimeSummary = this.overtimes.overtimeSummaries.find((x) => x.user.id == user.id);
        user.overtimeSummary = overtimeSummary || {workdayTimes: []};
      });

      this.state = "loaded";
      this.$scope.$apply();
    }, (error) => {
      this.state = "error";
      this.stateWorklog = "error";
      this.error = error;
    });
  }

  handleAcceptAll() {
    this.$rootScope.$broadcast("acceptAllWorklogs");
  }

  handleNewWorklog() {
    this.$rootScope.$broadcast("addNewWorklog");
  }

  handleSave() {
    this.$rootScope.$broadcast("saveWorklogs");
  }

  nextUser() {
    if (!this.summary.users || this.summary.users.length == 0)
      return;

    const currentUserIndex = this.summary.users.findIndex((x) => x.id == this.selectedUser.id);
    const usersNumber = this.summary.users.length;
    const newUserIndex = (currentUserIndex + 1) > (usersNumber - 1) ? 0 : (currentUserIndex + 1);
    this.selectedUser = this.summary.users[newUserIndex];
  }

  checkToggleAllGroup() {
    this.showAllclientGroupNames = angular.equals(this.$rootScope.hiddenClientsGroup, {});
  }

  checkToggleAllClients() {
    this.showAll = angular.equals(this.$rootScope.hiddenClients, {});
  }

  resetFilters() {
    this.clientGroupNames.map(x => x.show = true);
    setTimeout( () => this.showAll=true, 0);
    this.showAllclientGroupNames = true;
  }
}
